import React from "react";
import { Tabs, Tab } from "react-bootstrap";
import PrintPdf from "./PrintPdf";
import PrintPdfMaster from "./PrintPdfMaster";

function PrintTab() {
  return (
    <>
      <Tabs
        defaultActiveKey="printpdf"
        id="uncontrolled-tab-example"
        className="mb-3"
      >
        <Tab eventKey="printpdf" title="พิมพ์บัตรชาวไร่อ้อย">
          <PrintPdf />
        </Tab>
        <Tab eventKey="printpdfmaster" title="พิมพ์บัตรหัวหน้ากลุ่มชาวไร่อ้อย">
          <PrintPdfMaster />
        </Tab>
      </Tabs>
    </>
  );
}

export default PrintTab;
